import { useUserEnvironment } from 'store/hooks/useUserEnvironment';

export function useIsLoggedIn() {
  const { user } = useUserEnvironment();
  return Boolean(user);
}
